import { createFileRoute } from "@tanstack/react-router";
import AnalisisCompleto from "@/pages/AnalisisCompleto";
import { analisisCompletoHead } from "@/lib/analisisCompletoSeo";

export const Route = createFileRoute("/en/leak-detector")({
  head: () => analisisCompletoHead("en"),
  component: AnalisisCompleto,
});
